import { parseOrThrow } from "_shared/_utilities/zod-schema-parser";
import UserCoworkerSchema from "users/information/coworker-information/_schemas/user-coworker-schema";
import { z } from "zod";

export type ProposalReviewerCandidateSource = z.infer<typeof ProposalReviewerCandidateSchema.SourceZ>;
export type ProposalReviewerCandidateJSON = z.infer<typeof ProposalReviewerCandidateSchema.ProposalReviewerCandidateJSONZ>;

/**
 * One row of `GET work/proposal-negotiations/{id}/reviewer-candidates`: the same person fields as a
 * coworker, plus where the leader knows them from and whether they are on the other side of this
 * proposal.
 */
export default class ProposalReviewerCandidateSchema {
  public static readonly SourceZ = z.enum(["coworker", "teamMember"]);

  public static readonly ProposalReviewerCandidateJSONZ = UserCoworkerSchema.UserCoworkerJSONZ.extend({
    source: ProposalReviewerCandidateSchema.SourceZ,
    isCounterparty: z.boolean(),
  });

  public static validateJSON(json: unknown): ProposalReviewerCandidateJSON {
    return parseOrThrow(ProposalReviewerCandidateSchema.ProposalReviewerCandidateJSONZ, json, {
      logError: true,
      schemaName: "ProposalReviewerCandidateSchema",
      operation: "validateJSON",
      payloadSample: json,
    });
  }
}
